
import { IconWeight, IconSize, icon, IconName } from "../Icons.js";
import { backgroundColor_bgNeutral100, fontWeight_fontMedium, fontSize_textXs, alignItems_itemsCenter, display_flex, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { textColor_textNeutral700, borderRadius_roundedFull, textColor_textStatusDraftText, backgroundColor_bgStatusDraftBg, textColor_textStatusAbandonedText, backgroundColor_bgStatusAbandonedBg, textColor_textStatusFinalizedText, backgroundColor_bgStatusFinalizedBg, textColor_textStatusFinalizingText, backgroundColor_bgStatusFinalizingBg, textColor_textStatusActiveText, backgroundColor_bgStatusActiveBg, textColor_textStatusPledgedText, backgroundColor_bgStatusPledgedBg, textColor_textStatusPublishedText, backgroundColor_bgStatusPublishedBg, textColor_textStatusPlannedText, backgroundColor_bgStatusPlannedBg } from "../TailwindExtensions.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { concat } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { createElement } from "react";
import { ChallengeStatus } from "../Challenge.js";

function statusIcon(status) {
    switch (status.tag) {
        case 1:
            return new IconName(1, []);
        case 2:
            return new IconName(2, []);
        case 3:
            return new IconName(3, []);
        case 4:
            return new IconName(4, []);
        case 5:
            return new IconName(5, []);
        case 6:
            return new IconName(6, []);
        case 7:
            return new IconName(7, []);
        default:
            return new IconName(0, []);
    }
}

function statusLabel(status) {
    switch (status.tag) {
        case 1:
            return "Planned";
        case 2:
            return "Published";
        case 3:
            return "Pledged";
        case 4:
            return "Active";
        case 5:
            return "Finalizing";
        case 6:
            return "Finalized";
        case 7:
            return "Abandoned";
        default:
            return "Draft";
    }
}

function statusColors(status) {
    switch (status.tag) {
        case 1:
            return tw(ofArray([backgroundColor_bgStatusPlannedBg, textColor_textStatusPlannedText]));
        case 2:
            return tw(ofArray([backgroundColor_bgStatusPublishedBg, textColor_textStatusPublishedText]));
        case 3:
            return tw(ofArray([backgroundColor_bgStatusPledgedBg, textColor_textStatusPledgedText]));
        case 4:
            return tw(ofArray([backgroundColor_bgStatusActiveBg, textColor_textStatusActiveText]));
        case 5:
            return tw(ofArray([backgroundColor_bgStatusFinalizingBg, textColor_textStatusFinalizingText]));
        case 6:
            return tw(ofArray([backgroundColor_bgStatusFinalizedBg, textColor_textStatusFinalizedText]));
        case 7:
            return tw(ofArray([backgroundColor_bgStatusAbandonedBg, textColor_textStatusAbandonedText]));
        default:
            return tw(ofArray([backgroundColor_bgStatusDraftBg, textColor_textStatusDraftText]));
    }
}

export function render(status) {
    const label = statusLabel(status);
    return HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", "px-2", "py-0.5", borderRadius_roundedFull, fontSize_textXs, fontWeight_fontMedium, statusColors(status)]))], ["aria-label", concat("Status: ", label)], ["children", [createElement(icon, {
        name: statusIcon(status),
        size: new IconSize(0, []),
        weight: new IconWeight(1, []),
    }), label]]]));
}

export function fromString(status) {
    const parsed = (status === "draft") ? (new ChallengeStatus(0, [])) : ((status === "planned") ? (new ChallengeStatus(1, [])) : ((status === "published") ? (new ChallengeStatus(2, [])) : ((status === "pledged") ? (new ChallengeStatus(3, [])) : ((status === "active") ? (new ChallengeStatus(4, [])) : ((status === "finalizing") ? (new ChallengeStatus(5, [])) : ((status === "finalized") ? (new ChallengeStatus(6, [])) : ((status === "abandoned") ? (new ChallengeStatus(7, [])) : undefined)))))));
    if (parsed == null) {
        return HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, "gap-1.5", "px-2", "py-0.5", borderRadius_roundedFull, fontSize_textXs, fontWeight_fontMedium, backgroundColor_bgNeutral100, textColor_textNeutral700]))], ["aria-label", concat("Status: ", status)], ["children", [createElement(icon, {
            name: new IconName(31, []),
            size: new IconSize(0, []),
            weight: new IconWeight(1, []),
        }), status]]]));
    }
    else {
        return render(parsed);
    }
}

//# sourceMappingURL=StatusBadge.js.map
